import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ActivatedRoute, Params} from '@angular/router';

import {ProductsAbstractService} from './products-abstract.service';
import {ProductsLotAbstract} from './products-lot-abstract';
import {ProductsMovementAbstract} from './products-movement-abstract';


@Component({
    selector: 'products-abstract',
    styleUrls: ['./styles/products-abstract.component.css'],
    templateUrl: './templates/products-abstract.component.html',
    providers: [ProductsAbstractService]
})

export class ProductsAbstractComponent {
    stock_dispo = '';
    lot_list: ProductsLotAbstract[];
    movement_list: ProductsMovementAbstract[];
    id_article: number;

    constructor(private products_abstract_service: ProductsAbstractService, private route: ActivatedRoute) {
        this.GetMovementAbstract();
        this.GetLotAbstract();
    }

    GetMovementAbstract(): void {
        this.route.params.subscribe((params: Params) => {
            let id = params['id'];
            if (id !== undefined) {
                this.products_abstract_service.GetMovementAbstract(parseInt(id)).then(movement_list => this.movement_list = movement_list);
            }
        });

    }
    GetLotAbstract(): void {
        this.route.params.subscribe((params: Params) => {
            let id = params['id'];
            let stocks = params['stocks'];
            if (id !== undefined) {
                this.products_abstract_service.GetLotAbstract(parseInt(id)).then(lot_list => this.lot_list = lot_list);
                this.stock_dispo = ' / Stocks disponibles: ' + stocks;
            }
        });


    }

    ngOnInit(): void {
        this.GetMovementAbstract();
        this.GetLotAbstract();

    }

}



// WEBPACK FOOTER //
// ./src/app/products-abstract.component.ts